import { SpacingBlock } from 'components/spacing-block';
import React from 'react';
import { SectionWrapper } from '../../styled';
import { useLocale } from 'locale';
import { Content, NameWrapper, Qmark, Section, SectionIcon, SectionInfo, Title, Value, WeHaveIt, WeHaveText, WeHaveTitle } from './styled';
import PencilIcon from 'assets/svg/pencil-paper.svg';
import HandMoneyIcon from 'assets/svg/hand-money.svg';
import HandHomeIcon from 'assets/svg/hand-home.svg';
import Tooltip from 'ds/components/tooltip';
import { SmallText } from 'ds/components/typography';
import { ShowAt } from 'consts/breakpoints';
import { Button } from 'ds/components/button';
import { NavigateToFn, Route } from 'config/routes';

interface ISummaryProps {
  calculatedBudget?: {
    loanAmount: number;
    monthlyPayment: number;
    totalBudget: number;
  };
  navigateTo: NavigateToFn;
}

export const WizardSummary: React.FC<ISummaryProps> = ({ calculatedBudget, navigateTo }) => {
  const { t, formatMoney } = useLocale();

  const weHaveItTitle = 'יש לנו את זה!';
  const weHaveItText = 'אחרי שהבנו את הצרכים וההעדפות שלך, מערכת המידע וחיפוש הנכסים תתאים את עצמה אליך';
  const weHaveItButton = 'המשך לזירת המשקיעים שלי';

  const handleClick = () => {
    navigateTo(Route.InvestorsHomePage, {});
  };

  return (
    <>
      <ShowAt to={2}>
        <SpacingBlock mTop={5} />
      </ShowAt>
      <ShowAt from={3}>
        <SpacingBlock mTop={14} />
      </ShowAt>
      <Content style={{ maxWidth: 576 }}>
        <SectionWrapper style={{ paddingLeft: 24, paddingRight: 24 }}>
          <Title>{t('investors.wizard.summary.card.title')}</Title>
          <Section>
            <SectionIcon>
              <PencilIcon />
            </SectionIcon>
            <SectionInfo>
              <NameWrapper>
                {t('investors.wizard.summary.amountYouCanGet')}
                <Tooltip
                  size="medium"
                  placement="bottom"
                  tooltip={<SmallText>{t('investors.wizard.summary.amountYouCanGet.explanation')}</SmallText>}
                  tapThreshold={0}
                  wrapperStyle={{ maxWidth: 240 }}
                >
                  <Qmark />
                </Tooltip>
              </NameWrapper>
              <Value>{formatMoney(calculatedBudget.loanAmount)}</Value>
            </SectionInfo>
          </Section>
          <Section>
            <SectionIcon>
              <HandMoneyIcon />
            </SectionIcon>
            <SectionInfo>
              <NameWrapper>
                {t('investors.wizard.summary.monthlyRepayment')}
                <Tooltip
                  size="medium"
                  placement="bottom"
                  tooltip={<SmallText>{t('investors.wizard.summary.monthlyRepayment.explanation')}</SmallText>}
                  tapThreshold={0}
                  wrapperStyle={{ maxWidth: 240 }}
                >
                  <Qmark />
                </Tooltip>
              </NameWrapper>
              <Value>{formatMoney(calculatedBudget.monthlyPayment)}</Value>
            </SectionInfo>
          </Section>
          <Section>
            <SectionIcon>
              <HandHomeIcon />
            </SectionIcon>
            <SectionInfo>
              <NameWrapper>{t('investors.wizard.summary.investmentAmount')}</NameWrapper>
              <Value>{formatMoney(calculatedBudget.totalBudget)}</Value>
            </SectionInfo>
          </Section>
        </SectionWrapper>
        <ShowAt to={2}>
          <SpacingBlock mTop={3} />
        </ShowAt>
        <ShowAt from={3}>
          <SpacingBlock mTop={7} />
        </ShowAt>
        <WeHaveIt>
          <WeHaveTitle>{weHaveItTitle}</WeHaveTitle>
          <SpacingBlock mTop={1} />
          <WeHaveText>{weHaveItText}</WeHaveText>
          <SpacingBlock mTop={2} />
          <Button size="extraLarge" fullWidth onClick={handleClick}>{weHaveItButton}</Button>
        </WeHaveIt>
      </Content>
    </>
  );
};
